const normalizeUrl = (url) => {
  if (!url) return "";
  return url.endsWith("/") ? url : `${url}/`;
};

export const env = {
  API_ENDPOINT_URL: normalizeUrl(process.env.REACT_APP_API_ENDPOINT_URL),
};
